<template>
  <div>
    <div class="flex">
      <vs-button class="w-full" @click="enrollmentModal = true" color="primary" type="filled"
        >Enrol Student</vs-button
      >
      <!-- <vs-button class="w-full" @click="popupActivo2 = true" color="primary" type="filled"
        >Enrol Student</vs-button
      > -->
      <vs-popup
        class="medium fixed_medium"
        classContent="popup-example"
        title="Enrol Student"
        :active.sync="popupActivo2"
      >
        <!---start Step--->
        <div id="widgets-selection-container" class="modal-content">
          <form-wizard
            shape="square"
            class="cstm_form_wizard admission_wizard"
            title=""
            subtitle=""
            stepSize="xs"
            color="rgb(var(--vs-primary))"
            ref="wizard"
          >
            <!-- Tab 1 -->
            <tab-content title="Course Type">
              <h5 class="mb-4 text-center">Choose Any One</h5>
              <div class="flex flex-wrap stepOne">
                <div class="flex flex-1 flex-col">
                  <div class="customRadio admission_radio mx-auto">
                    <vs-radio v-model="chooseCourseType" vs-value="online_one_2_one">
                      <!-- <figure>
                        <img
                          class="responsive"
                          src="@/assets/images/one-one.png"
                          alt="banner"
                        />
                      </figure> -->
                      <span style="font-size: 200px;" class="material-icons-outlined admission_icon">supervisor_account</span>
                      <h5 class="my-2 text-center">One to One</h5>
                    </vs-radio>
                  </div>
                </div>

                <div class="vertical-divider"></div>

                <div class="flex flex-1 flex-col">
                  <div class="customRadio admission_radio mx-auto">
                    <vs-radio v-model="chooseCourseType" vs-value="online_one_2_many">
                      <!-- <figure>
                        <img
                          class="responsive"
                          src="@/assets/images/one-many.png"
                          alt="banner"
                        />
                      </figure> -->
                      <span style="font-size: 200px;" class="material-icons-outlined admission_icon">groups</span>
                       <h5 class="my-2 text-center">Group</h5>
                    </vs-radio>
                  </div>
                </div>
              </div>
            </tab-content>

            <!-- Tab 2 -->
            <tab-content title="Course Selection">
              <div class="mb-4">
                <vs-row>
                  <vs-col vs-lg="9" vs-sm="12" vs-xs="12">
                    <vs-row>
                      <vs-col class="p-1" vs-lg="6" vs-sm="12" vs-xs="12">
                        <v-select placeholder="Course Type"
                           class="w-full"
                          :options="courseType"
                          :reduce="(option) => option.value"
                          v-model="courseTypeFilter"
                          label="name">
                        </v-select>
                      </vs-col>
                      <vs-col class="p-1" vs-lg="6" vs-sm="12" vs-xs="12">
                        <v-select placeholder="Select Subject"  class="w-full"
                          :options="subjectlist"
                          :reduce="(option) => option.id"
                          v-model="courseSubjectFilter"
                          label="subject_name">
                        </v-select>
                      </vs-col>
                    </vs-row>
                  </vs-col>
                  <vs-col vs-lg="3" vs-sm="12" vs-xs="12" class="flex justify-end">
                    <div class="p-1 flex">
                      <vs-tooltip text="Search">
                        <vs-button
                          type="border"
                          icon-pack="feather"
                          icon="icon-search"
                          @click="shortCourseList"
                        ></vs-button>
                      </vs-tooltip>

                      <vs-tooltip text="Reset">
                        <vs-button
                          type="border"
                          icon-pack="feather"
                          icon="icon-refresh-ccw"
                          class="ml-2"
                          @click="resetFilter"
                        ></vs-button>
                      </vs-tooltip>
                    </div>
                  </vs-col>
                </vs-row>
              </div>
              <vs-divider />
              <!--start slider-->
              <h5 class="text-center mb-4">Choose any one from list</h5>
              <!-- <swiper
                :options="swiperOption"
                :key="$vs.rtl"
              > -->
              <div style="height: calc(100vh - 370px); overflow: auto;" class="flex flex-wrap vertical_scrollbar">
                <!-- <swiper-slide v-for="(roomimage, index) in inventObj.asset_images" :key="index"> -->
                <div class="lg:w-1/3 md:w-1/2 w-full p-2" v-for="(course, index) in courseList" :key="index">
                  <!-- <img class="responsive" :src="roomimage.files_details.file_path" alt="banner"> -->
                  <div class="customRadio w-full cstm_bg">
                    <vs-radio v-model="courseChoosen" :vs-value="course">
                        <img
                          class="responsive"
                          src="https://scoolio-alpha.s3.eu-west-2.amazonaws.com/default_course_image.png"
                          alt="banner"
                        />
                        <article class="course_article">
                          <div class="my-4">
                            <h5 class="mb-2 course-heading">{{course.name}}</h5>                            
                          </div>
                          <div class="flex flex-wrap items-center justify-between">
                            <div class="inline-flex items-center w-full">
                              <!-- <img
                                src="@/assets/images/pages/user-circle-solid.svg"
                                alt="user-img"
                                width="30"
                                height="30"
                                style="object-fit: contain"
                                class="rounded-full shadow-md cursor-pointer block mr-2"
                              /> -->
                              <div class="admission_teacher_name_holder">
                                <span class="each_name" v-for="(teacher, teacherIndex) in course.instructors" :key="teacherIndex">
                                  <vs-tooltip :text="`${teacher.first_name} ${teacher.last_name}`" color="primary" position="top">
                                    <span>
                                      <img
                                        v-if="teacher.picture"
                                        style="width: 30px; height: 30px; object-fit: contain;"
                                        class="person-img rounded-full"
                                        :src="teacher.picture"
                                      />
                                      <svg v-else style="width: 30px; height: 30px;" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user-circle" class="svg-inline--fa fa-user-circle fa-w-16 person-img rounded-full shadow-md block mr-0" role="img" viewBox="0 0 496 512"><path fill="currentColor" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"/></svg>
                                    </span>
                                  </vs-tooltip>
                                </span>
                              </div>
                            </div>
                          </div>
                        </article>
                    </vs-radio>
                  </div>
                </div>
              </div>
                <!-- <div class="swiper-pagination" slot="pagination"></div>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
              </swiper> -->
              <!--end slider-->
            </tab-content>

            <!-- Tab 3 -->
            <tab-content title="Students">
              <!-- <form>
                <div class="vs-row" style="display: flex; width: 100%">
                  <v-select
          class="w-full"
          :getOptionLabel="(item) => `${item.first_name} ${item.last_name}`"
          :options="studentList"
          :reduce="(option) => option.client_users_id"
          v-model="selectedStudents"
          placeholder="Select Student"
          name="Student Name"
          data-vv-name="Student Name"
          :multiple="chooseCourseType !== 'online_one_2_one'"
        ></v-select>
                </div>
              </form> -->
              <div style="max-height: calc(100vh - 280px); overflow: auto;" class="vertical_scrollbar p-2 relative">
                <h4 class="absolute_table_heading">{{ chooseCourseType !== 'online_one_2_one' ? 'Select Students' : 'Select Student'}}</h4>
                <vs-table class="cstm_vuexy_table" :multiple="chooseCourseType !== 'online_one_2_one'" v-model="selectedStudents" :data="studentList" search>
                  <template slot="thead">
                    <vs-th>Students</vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td class="avatar_name_td" :data="data[indextr].picture">
                          <img
                            v-if="data[indextr].picture"
                            style="width: 40px;"
                            class="person-img rounded-full shadow-md block"
                            :src="data[indextr].picture"
                          />
                          <svg v-else style="width: 40px;" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user-circle" class="svg-inline--fa fa-user-circle fa-w-16 person-img rounded-full shadow-md block" role="img" viewBox="0 0 496 512"><path fill="currentColor" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"/></svg>
                          <!-- <img
                            v-else
                            class="person-img rounded-full shadow-md block"
                            src="@/assets/images/pages/user-circle-solid.svg"
                          /> -->
                          <span class="ml-2">
                            {{ data[indextr].first_name }} {{ data[indextr].middle_name }} {{ data[indextr].last_name }}
                          </span>
                        </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </tab-content>

            <!-- Tab 4 -->
            <tab-content title="Teachers">
              <div style="max-height: calc(100vh - 480px); overflow: auto;" class="vertical_scrollbar p-2 relative">
                <h4 class="absolute_table_heading">Select Teacher</h4>
                <vs-table class="cstm_vuexy_table" v-model="courseTeacher" :data="courseChoosen.instructors" search>
                    <template slot="thead">
                      <vs-th>Teachers</vs-th>
                    </template>
                    <template slot-scope="{ data }">
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                          <vs-td class="avatar_name_td" :data="data[indextr]">
                             <img
                            v-if="data[indextr].picture"
                            style="width: 40px;"
                            class="person-img rounded-full shadow-md block"
                            :src="data[indextr].picture"
                          />
                            <svg v-else style="width: 40px;" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user-circle" class="svg-inline--fa fa-user-circle fa-w-16 person-img rounded-full shadow-md block" role="img" viewBox="0 0 496 512"><path fill="currentColor" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"/></svg>
                            {{data[indextr].first_name}}{{data[indextr].last_name}}
                          </vs-td>
                      </vs-tr>
                    </template>
                </vs-table>
              </div>
              <form>
                <!-- <div class="vs-row" style="display: flex; width: 100%">
                  <div class="vs-col p-2 vs-xs-12 vs-sm-12 vs-lg-12">
                    <label class="vs-input--label">Select Teacher</label>
                    <v-select
                      :getOptionLabel="(item) => `${item.first_name} ${item.last_name}`"
                      class="w-full"
                          :options="courseChoosen.instructors"
                          :reduce="(option) => option.id"
                          v-model="courseTeacher">
                    </v-select>
                  </div>
                  </div> -->
                   <div class="vs-row" style="display: flex; width: 100%" v-if="chooseCourseType === 'online_one_2_one'">
                  <div class="vs-col p-2 vs-xs-12 vs-sm-12 vs-lg-12">
                    <label class="vs-input--label">Start Date</label>
                    <flat-pickr
                    v-model="startDate"
                    :config="config"
                    name="Date"
                    class="form-control w-full"
                  ></flat-pickr>
                  </div>
                  </div>
          
                  <div class="vs-row" style="display: flex; width: 100%" v-if="courseChoosen !== '' && chooseCourseType === 'online_one_2_one'">
                  <div class="vs-col p-2 w-full" v-if="courseChoosen.courseSettings.session_frequency === 4">
                    <label class="vs-input--label">Select Date</label>
                   
                    <div class="flex flex-wrap cstm_calendar_view_holder mt-2" >
                      <div class="md:w-2/5 left_view_panel">
                        <div class="text-center">
                          <small class="block w-full text-center">Days</small>
                          <span class="day_holder" v-for="(date, index) in selectedFreq" :key="index">
                            {{ date }}
                            <span v-if="index+1 < selectedFreq.length">,</span>
                          </span>
                          <span v-if="selectedFreq.length == 0" class="day_holder mt-2" style="font-size: 13px;">No dates selected</span>
                        </div>
                      </div>
                      <div class="md:w-3/5 right_view_panel" :class="[disabledChecking ? 'disableCheckbox' : '']">
                        <vs-checkbox class="monthview_radio"
                          v-for="(eachopt, eachoptindex) in getOptionFrequency" :key="eachoptindex"
                          v-model="selectedFreq" :vs-value="eachopt"
                        >{{eachopt}}</vs-checkbox>

                        <i class="w-full text-right px-4" style="font-size: 12px; color: #ff7171; font-weight: 500;">(** Note: You must select {{courseChoosen.courseSettings.max_days_in_week_or_month}} {{courseChoosen.courseSettings.max_days_in_week_or_month==1?'day' :'days'}})</i>
                      </div>
                    </div>

                    <div class="timeslot_holder">
                      <vs-card class="vx_card" v-for="(date, index) in selectedCombination" :key="index">
                        <div slot="header">
                          <h6>Timeslots for Day: {{ date.eachDay }}</h6>
                        </div>
                        <label class="vs-input--label block mb-2">Select timeslot</label>
                        <vs-radio 
                          v-for="(time, timeindex) in date.timeOptions" :key="timeindex"
                          v-model="date.timingObject" :vs-name="`radios1${index}`" :vs-value="time"
                        >
                          {{time.start_time | OnlytimeFormatLocalization}} - {{time.end_time | OnlytimeFormatLocalization}}
                        </vs-radio>
                      </vs-card>
                    </div>
                    <!-- end of sayan's code -->
                  </div>
                  <div class="vs-col p-2 w-full" v-if="courseChoosen.courseSettings.session_frequency === 2">
                    <label class="vs-input--label">Select Day</label>
                    <div class="flex flex-wrap cstm_calendar_view_holder mt-2" >
                      <div class="md:w-2/5 left_view_panel">
                        <div class="text-center">
                          <small class="block w-full text-center">Days</small>
                          <span class="day_holder day_view_holder" v-for="(date, index) in selectedFreq" :key="index">
                            {{ date }}
                            <span v-if="index != selectedFreq.length - 1">,</span>
                          </span>
                          <span v-if="selectedFreq.length == 0" class="day_holder mt-2" style="font-size: 13px;">No dates selected</span>
                        </div>
                      </div>
                      <div class="md:w-3/5 right_view_panel" :class="[disabledChecking ? 'disableCheckbox' : '']">
                        <vs-checkbox class="weekview_radio"
                          v-for="(eachopt, eachoptindex) in weekDays" :key="eachoptindex"
                          v-model="selectedFreq" :vs-value="eachopt.value"
                        >{{eachopt.name}}</vs-checkbox>

                        <i class="w-full text-right px-4" style="font-size: 12px; color: #ff7171; font-weight: 500;">(** Note: You must select {{courseChoosen.courseSettings.max_days_in_week_or_month}} {{courseChoosen.courseSettings.max_days_in_week_or_month==1?'day' :'days'}})</i>
                      </div>
                    </div>

                    <div class="timeslot_holder">
                      <vs-card class="vx_card" v-for="(date, index) in selectedCombination" :key="index">
                        <div slot="header">
                          <h6>Timeslots for Day: {{ date.eachDay }}</h6>
                        </div>
                        <label class="vs-input--label block mb-2">Select timeslot</label>
                        <vs-radio 
                          v-for="(time, timeindex) in date.timeOptions" :key="timeindex"
                          v-model="date.timingObject" :vs-name="`radios1${index}`" :vs-value="time"
                        >
                          {{time.start_time | OnlytimeFormatLocalization}} - {{time.end_time | OnlytimeFormatLocalization}}
                        </vs-radio>
                      </vs-card>
                    </div>
                    <!-- end of sayan's code -->
                  </div>
                   <div class="vs-col p-2 w-full" v-if="courseChoosen.courseSettings.session_frequency === 1">
                    <label class="vs-input--label">Select Day</label>
                    <vs-input
                      type="text"
                      v-model="daily"
                      readonly
                      class="form-control w-full"
                    />
                  
                  
                  <div class="timeslot_holder">
                      <vs-card class="vx_card" v-for="(date, index) in selectedCombination" :key="index">
                        <div slot="header">
                          <h6>Timeslots from: {{ date.eachDay | dateFormatLocalization }}</h6>
                        </div>
                        <label class="vs-input--label block mb-2">Select timeslot</label>
                        <vs-radio 
                          v-for="(time, timeindex) in date.timeOptions" :key="timeindex"
                          v-model="date.timingObject" :vs-name="`radios1${index}`" :vs-value="time"
                        >
                          {{time.start_time | OnlytimeFormatLocalization }} - {{time.end_time | OnlytimeFormatLocalization}}
                        </vs-radio>
                      </vs-card>
                    </div>
                    </div>
                  </div>
              </form>
            </tab-content>

            <!-- Tab 5 -->
            <tab-content title="Payment">
              <div class="vs-row mb-4" style="display: flex; width: 100%">
                <div class="vs-col vs-xs-12 vs-sm-6 vs-lg-6 p-1">
                    <v-select
                          placeholder="Select Payment Type"
                           class="w-full"
                          :options="paymentMethod"
                          :reduce="(option) => option.name"
                          v-model="selectedPaymentMothod"
                          label="name"></v-select>
                  <!-- </div> -->
                </div>
                <div class="vs-col vs-xs-12 vs-sm-6 vs-lg-6 p-1">
                  <flat-pickr
                    v-model="selecedDate"
                    :config="config"
                    placeholder="Choose Date"
                    name="Date"
                    class="form-control w-full"
                  ></flat-pickr>
                </div>
              </div>

              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="12"
              >
                <vs-card class="cstm-card w-full mb-4 collapse-cstm-card">
                  <div class="collapse-item">
                    <div
                      class="flex justify-between header"
                      slot="header"
                      @click="isCollapseCard = !isCollapseCard"
                      :class="{ activeCollapse: isCollapseCard }"
                    >
                      <h5>Upload any required admission files</h5>
                      <span class="material-icons">keyboard_arrow_down</span>
                    </div>
                    <div
                      class="collapseContent"
                      v-show="isCollapseCard"
                      :class="{ active: isCollapseCard }"
                    >
                      <div class="flex justify-between">
                        <vs-button
                          class="mb-2"
                          color="primary"
                          type="filled"
                          @click.prevent="switchTheme"
                        >
                          <span v-if="theme != 'list'" class="material-icons-outlined">format_list_bulleted</span>
                          <!-- <span v-if="theme != 'list'">List View</span> -->
                          <span v-if="theme == 'list'" class="material-icons-outlined">grid_view</span>
                          <!-- <span v-if="theme == 'list'">Grid View</span> -->
                        </vs-button>
                      </div>
                      <div class="cstm_vuefileagent_holder">
                        <VueFileAgent
                        @isBrowseContent="isBrowseContent = true"
                          ref="vueFileAgent"
                          :theme="theme"
                          :multiple="true"
                          :deletable="true"
                          :meta="true"
                          :accept="'image/*,.pdf,.doc,.docx'"
                          :maxSize="'10000MB'"
                          :maxFiles="100"
                          :helpText="'Choose or drag and drop image here to upload'"
                          :errorText="{
                            type: 'Only images and docs allowed',
                            size: 'Files should not exceed 10000MB in size',
                          }"
                          @select="filesSelected($event)"
                          @beforedelete="onBeforeDelete($event)"
                          @delete="fileDeleted($event)"
                          v-model="fileRecords"
                        ></VueFileAgent>
                        <p class="or_text_holder">(or)</p>
              <vs-tooltip class="inline-block align-bottom" color="primary"
                text="Import File From Your Existing System"
              >
                <vs-button
                  icon="folder_special"
                  class="mb-6 mx-1 icon_large_btn"
                  color="primary"
                  type="border"
                  @click="isBrowseContent = true"
                  ></vs-button
                >
              </vs-tooltip>
              <vs-tooltip class="inline-block align-bottom" color="primary"
                text="Select files From Gdrive"
              >
                <vs-button
                  class="mb-6 mx-1 icon_large_btn includeIcon includeIconOnly"
                  color="primary"
                  type="border"
                  @click="driveIconClicked('Admissions')"
                  >
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "/><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "/><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "/></g></svg>
                </vs-button>
              </vs-tooltip>
                      </div>
  <vs-button class="mt-4" v-if="fileRecordsForUpload.length === 1" @click="uploadFiles(1)">
      Upload {{ fileRecordsForUpload.length }} file
    </vs-button>
    <vs-button class="mt-4" v-if="fileRecordsForUpload.length > 1" @click="uploadFiles(2)">
      Upload {{ fileRecordsForUpload.length }} files
    </vs-button>
                      <div>
                        <vs-divider />
                      </div>
                    </div>
                  </div>
                </vs-card>
              </vs-col>
            </tab-content>
            <template slot="footer" slot-scope="props">
              <div class="wizard-footer-left">
                <vs-button v-if="props.activeTabIndex == 1 && !props.isLastStep" @click.native="props.prevTab()">Previous</vs-button>
                <vs-button v-if="props.activeTabIndex == 2 && !props.isLastStep" @click.native="props.prevTab()">Previous</vs-button>
                <vs-button v-if="props.activeTabIndex == 3 && !props.isLastStep" @click.native="props.prevTab()">Previous</vs-button>
                <vs-button v-if="props.activeTabIndex == 4 && props.isLastStep" @click.native="props.prevTab()">Previous</vs-button>
              </div>
              <div class="wizard-footer-right">
                <vs-button v-if="props.activeTabIndex == 0" :disabled="chooseCourseType === ''" @click.native="props.nextTab()" class="wizard-footer-right">Next</vs-button>
                <vs-button v-if="props.activeTabIndex == 1" :disabled="courseChoosen === ''"  @click.native="props.nextTab()" class="wizard-footer-right">Next</vs-button>
                <vs-button v-if="props.activeTabIndex == 2" :disabled="!show3rdStepButton" @click.native="props.nextTab()" class="wizard-footer-right">Next</vs-button>
                <vs-button v-if="props.activeTabIndex == 3 && chooseCourseType === 'online_one_2_one'" :disabled="!show4thStepButton" @click.native="props.nextTab()" class="wizard-footer-right">Next</vs-button>
                <vs-button v-if="props.activeTabIndex == 3 && chooseCourseType !== 'online_one_2_one'" :disabled="!show4thStepButtonForOneToMany" @click.native="props.nextTab()" class="wizard-footer-right">Next</vs-button>
                <!-- <vs-button v-if="props.activeTabIndex == 3 && chooseCourseType === 'online_one_2_one' && courseChoosen.courseSettings.session_frequency === 1" :disabled="!show4thStepButtonForDaily" @click.native="props.nextTab()" class="wizard-footer-right">Next</vs-button> -->
                <!-- <vs-button v-if="props.activeTabIndex == 3 && chooseCourseType !== 'online_one_2_one' && courseChoosen.courseSettings.session_frequency !== 1" :disabled="!show5thStepButton" @click="submit"  class="wizard-footer-right">Done</vs-button> -->
                <vs-button v-if="props.activeTabIndex == 4" :disabled="!show5thStepButton" @click="submit" class="wizard-footer-right">Done</vs-button>
              </div>
            </template>
          </form-wizard>
        </div>
        <!---end Step--->
      </vs-popup>
    </div>
     <div v-if="isBrowseContent">
      <vs-popup fullscreen title="Browse Item" :active.sync="isBrowseContent" class="childImportPopUp browse_modal_item">
        <import-browse-files-model
          v-if="isBrowseContent"
          :file_repository_id="repository_id"
          @getImportFile="getImportFile"
          :multipleSelect="true"
        ></import-browse-files-model>
      </vs-popup>
    </div>
    <vs-popup
        fullscreen
        classContent="popup-example"
        title="Enrol Student"
        :active.sync="enrollmentModal">
      <Enrollment @enrollmentComplete="enrollmentComplete" :clearWizard="clearWizard" />
    </vs-popup>
  </div>
</template>
<script>
import Enrollment from '@/views/pages/v1/admission/newEnrollment.vue'
import vSelect from 'vue-select'
import ImportBrowseFilesModel from '@/components/common/ImportBrowseFilesModel.vue'
import {GoogleAuthorization} from '@/mixins/common/GoogleAuthorization.js'
import { Subject } from '@/mixins/subject/subject'
import { FormWizard, TabContent, WizardButton } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import PercentageCircle from 'vue-css-percentage-circle'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { shortStudentListApi } from '@/api/student'
import { shortCourseList, scheduleTiming, courseEnroll} from '@/api/admission'
import { addFile } from '@/api/file.js'
import {repository} from '@/mixins/repository.js'
export default {
  name: 'UModal',
  mixins:[Subject, GoogleAuthorization, repository],
  data () {
    return {
      //sayantani
      clearWizard:false,
      filesInfo: [],
      enrollmentModal:false,
      file_repository_id: '',
      isBrowseContent: false,
      addedSchedule: [],
      availableTime: [],
      filesId: [],
      theme: 'list',
      uploadFilesAll: [],
      fileRecords: [],
      uploadUrl: '',
      uploadHeaders: { 'X-Test-Header': 'vue-file-agent', 'Authorization': '' },
      fileRecordsForUpload: [],
      studentList: [],
      selectedStudents: [],
      chooseCourseType: '',
      courseList: [],
      courseChoosen: '',
      scheduleDate:'',
      startDate: '',
      scheduleTime:'',
      courseTeacher: null,
      selectedPaymentMothod: '',
      selecedDate: '',
      allAvailableTime: {},
      weekDays:[
        {
          value: 'Sunday',
          name: 'Sunday'
        },
        {
          value: 'Monday',
          name: 'Monday'
        },
        {
          value: 'Tuesday',
          name: 'Tuesday'
        },
        {
          value: 'Wednesday',
          name: 'Wednesday'
        },
        {
          value: 'Thursday',
          name: 'Thursday'
        },
        {
          value: 'Friday',
          name: 'Friday'
        },
        {
          value: 'Saturday',
          name: 'Saturday'
        }
      ],
      paymentMethod: [
        {
          id: 1,
          name: 'Cash'
        },
        {
          id: 2,
          name: 'Card'
        }
      ],
      courseType:[
        {
          value: 1,
          name: 'Open'
        },
        {
          value: 2,
          name: 'Free'
        },
        {
          value: 3,
          name: 'Paid'
        },
        {
          value: 4,
          name: 'Recurring'
        }
      ],
      courseTypeFilter: '',
      courseClassTypeFilter: '',
      courseSubjectFilter: '',
      //sayantani
      popupActivo2: false,
      swiperOption: {
        spaceBetween: 10,
        slidesPerView: 3,
        observer: true,
        observeParents: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        breakpoints: {
          480: {
            slidesPerView: 1,
            spaceBetween: 20
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20
          }

        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      value: '',
      date: null,
      config: {
        altInput: true,
        altFormat: 'j F, Y',
        dateFormat: 'Y-m-d'
      },
      isCollapseCard: true,
      //sayan
      selectedFreq: [],
      selectedCombination: [],
      selectedFreq1: [],
      radios1: '',
      getOptionFrequency: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
    }
  },
  components: {
    FormWizard,
    ImportBrowseFilesModel,
    TabContent,
    WizardButton,
    swiper,
    swiperSlide,
    PercentageCircle,
    flatPickr,
    vSelect,
    Enrollment
  },
  async created () {
    this.fetchSubjectList()
    await this.getRepositoryId(this.ADMISSIONS_MODULE_ID)
    this.file_repository_id = this.repository_id
    const customer_id = localStorage.getItem('customer_id')
    const imageUploadUrl = process.env.VUE_APP_IMAGE_UPLOAD_URL
    this.uploadUrl = `${imageUploadUrl}${customer_id}`
    this.uploadHeaders.Authorization = `Bearer ${JSON.parse(
      localStorage.getItem('access_token')
    )}`
    this.imagevalidation = 'image/*,video/*,audio/*,.pdf,.doc,.docx'
    this.imageHint = 'Choose or drag and drop image here to upload'
  },
  computed: {
    disabledChecking () {
      return this.selectedFreq.length >= this.courseChoosen.courseSettings.max_days_in_week_or_month || this.startDate === '' || this.courseTeacher === null
    },
    show3rdStepButton () {
      if (this.chooseCourseType !== 'online_one_2_one' && this.selectedStudents.length !== 0) {
        return true
      } else if (this.chooseCourseType === 'online_one_2_one' && this.selectedStudents !== null) {
        return true
      } else {
        return false
      }
    },
    show4thStepButton () {
      if (this.selectedCombination.length === this.courseChoosen.courseSettings.max_days_in_week_or_month) {
        const getData = this.selectedCombination.filter((item) => {
          // eslint-disable-next-line eqeqeq
          return item.timingObject == null
        })
        if (getData.length === 0) { 
          return true
        }
      } else if ((this.courseChoosen.courseSettings.session_frequency === 1 && this.selectedCombination.length === 1) || (this.courseChoosen.courseSettings.session_frequency === 0 && this.selectedCombination.length === 1)) {
        const getData = this.selectedCombination.filter((item) => {
          // eslint-disable-next-line eqeqeq
          return item.timingObject == null
        })
        if (getData.length === 0) { 
          return true
        }
      } else {
        return false
      }
    },
    show4thStepButtonForOneToMany () {
      if (this.courseTeacher !== null) {
        return true
      } else {
        return false
      }
    },
    show4thStepButtonForDaily () {
      if (this.addedSchedule.length !== 0) {
        return true
      } else {
        return false
      }
    },
    show5thStepButton () {
      if (this.selectedPaymentMothod !== '' && this.selecedDate !== '') {
        return true
      } else {
        return false
      }
    },
    daily () {
      if (this.courseChoosen.courseSettings.session_frequency === 1) {
        return `${this.courseChoosen.courseSettings.class_duration} days daily from start date`
      }
    }
  },
  watch: {
    enrollmentModal () {
      if (!this.enrollmentModal) {
        this.clearWizard = true
      }
    },
    popupActivo2 () {
      if (this.popupActivo2 === true) {
        this.fetchStudentList()
      }
    },
    chooseCourseType () {
      if (this.chooseCourseType !== '') {
        this.shortCourseList()
      }
    },
    courseChoosen () {
      if (this.selectedCombination.length !== 0) {
        this.selectedCombination = []
        this.courseTeacher = null
        this.startDate = ''
      }
    },
    selectedFreq: {
      handler (newVal, oldVal) {
        if (this.selectedFreq.length !== 0 && newVal.length > oldVal.length) {
          this.fetchScheduleTiming(this.selectedFreq[this.selectedFreq.length - 1])
        } else if (newVal.length < oldVal.length) {
          const getData = oldVal
            .filter(x => !newVal.includes(x))
            .concat(newVal.filter(x => !oldVal.includes(x)))
          this.selectedCombination = this.selectedCombination.filter((item) => {
            return item.eachDay !== getData[0]
          })
        }
      }
    },
    startDate () {
      if (this.startDate !== '') {
        if ((this.courseChoosen.courseSettings.session_frequency === 1 && this.courseTeacher !== null) || (this.courseChoosen.courseSettings.session_frequency === 0 && this.courseTeacher !== null)) {
          this.fetchScheduleTiming(this.startDate)
        } else if ((this.courseChoosen.courseSettings.session_frequency === 4) || (this.courseChoosen.courseSettings.session_frequency === 2)) {
          console.log('')
        } else {
          this.errorMsg('Please choose teacher and start date')
        }
      }
    }
  },
  methods: {
    async enrollmentComplete () {
      this.enrollmentModal = false
      this.clearWizard = true
      this.$emit('afterSubmission')
    },
    gonext () {
      alert(this.$refs.wizard.activeTabIndex)
    },
    switchTheme () {
      this.theme = this.theme === 'list' ? 'default' : 'list'
    },
    async fetchStudentList () {
      try {
        const { data } = await shortStudentListApi(localStorage.getItem('customer_id'))
        this.studentList = data.data.clientUser
      } catch (e) {
        //
      }
    },
    async shortCourseList () {
      try {
        const type = []
        if (this.chooseCourseType === 'online_one_2_one') {
          type.push('online_one_2_one', 'offline_one_2_one')
        } else {
          type.push('online_one_2_many', 'offline_one_2_many')
        }
        
        const payload = {
          course_class_type: type,
          subject_id: this.courseSubjectFilter === '' ? [] : [this.courseSubjectFilter],
          //class_type: [this.courseClassTypeFilter],
          course_type: this.courseTypeFilter === '' ? [] : [this.courseTypeFilter]
        }
        const { data } = await shortCourseList(localStorage.getItem('customer_id'), payload)
        this.courseList = data.data.course_list
      } catch (e) {
        //
      }
    },
    async fetchScheduleTiming (day) {
      try {
        //const extractMonth = this.scheduleDate.split('-')[1]
        const createDay = []
        if (this.courseChoosen.courseSettings.session_frequency === 4) {
          //const todayDate = this.$moment(new Date()).format('D')
          const getDay = this.$moment(this.startDate).format('D')
          let getMonth = this.$moment(this.startDate).format('M')
          let getYear = this.$moment(this.startDate).format('YYYY')
 
          if (getDay > day) {
            getMonth++
          }
         
          for (let i = 0; i < this.courseChoosen.courseSettings.class_duration; i++) {
            if (getMonth > 12) {
              getMonth = 12
            }
            let month = getMonth++
            month  = month.toString().padStart(2, '0')
            createDay.push(`${getYear}-${month}-${day}`)
            if (getMonth > 12) {
              getYear++
              getMonth = 1
            }
          }
          console.log(createDay)
          
        }
        const weekDay = day
        const payload = {
          course_id: this.courseChoosen.id,
          schedule_date: this.startDate,
          teacher_id: this.courseTeacher,
          customer_id: localStorage.getItem('customer_id')
        }
        if (this.courseChoosen.courseSettings.session_frequency === 4) {
          payload.courseDays = createDay
        } else if (this.courseChoosen.courseSettings.session_frequency === 2) {
          payload.day = weekDay
        }
        
        const { data } = await scheduleTiming(payload)
        if (this.courseChoosen.courseSettings.session_frequency === 1 || this.courseChoosen.courseSettings.session_frequency === 0) {
          this.selectedCombination = [{eachDay:day, timingObject:null, timeOptions: data.data.timing}]
        } else {
          this.selectedCombination.push({
            eachDay:day, timingObject:null, timeOptions: data.data.timing
          }) 
        }
      } catch (e) {
        this.errorMsg('No schedule available for that day')
      }
    },
    resetFilter () {
      this.courseClassTypeFilter = ''
      this.courseTypeFilter = ''
      this.courseSubjectFilter = ''
    },
    async submit () {
      try {
        if (typeof (this.selectedStudents) === 'number') {
          this.selectedStudents = [this.selectedStudents]
        }
        const formatedDateAndTime = []
        for (let index = 0; index < this.selectedCombination.length; index++) {
          formatedDateAndTime.push({
            day: this.courseChoosen.courseSettings.session_frequency === 4 ? this.selectedCombination[index].eachDay : this.selectedCombination[index].eachDay,
            start_time: this.selectedCombination[index].timingObject.start_time,
            end_time: this.selectedCombination[index].timingObject.end_time
          })
        }
        const payload = {
          course_id: this.courseChoosen.id,
          course_start_date: this.startDate,
          teacher_id: this.courseChoosen.instructors[0].id,
          session_frequency_week_day: formatedDateAndTime,
          session_frequency_month_day: [],
          clientUser: this.selectedStudents,
          payment_type: this.selectedPaymentMothod,
          payment_date: this.selecedDate,
          file_id: this.filesId
        }
        if (this.chooseCourseType === 'online_one_2_one' && this.courseChoosen.courseSettings.session_frequency === 4) {
          payload.session_frequency_week_day = []
          payload.session_frequency_month_day = formatedDateAndTime
        } else if ((this.chooseCourseType === 'online_one_2_one' && this.courseChoosen.courseSettings.session_frequency === 0) || (this.chooseCourseType === 'online_one_2_one' && this.courseChoosen.courseSettings.session_frequency === 1)) {
          payload.course_start_time = this.selectedCombination[0].timingObject.start_time
          payload.course_end_time = this.selectedCombination[0].timingObject.end_time
          payload.session_frequency_week_day = []
          payload.session_frequency_month_day = []
        }
        const { data } = await courseEnroll(localStorage.getItem('customer_id'), payload)
        this.popupActivo2 = false
        this.successMsg('Student Enrolled successfully')
        this.$emit('afterSubmission')
        this.clearSubmittedData()
      } catch (e) {
        this.errorMsg('Something Went Wrong')
      }
    },
    clearSubmittedData () {
      this.chooseCourseType = ''
      this.courseChoosen = ''
      this.selectedFreq = []
      this.scheduleTime = ''
      this.selectedStudents = []
      this.selectedPaymentMothod = ''
      this.selecedDate = ''
      this.fileRecords = []
    },
    uploadFiles (noOfFiles) {
      const data = this.$refs.vueFileAgent.upload(
        this.uploadUrl,
        this.uploadHeaders,
        this.fileRecordsForUpload,
        function createFormData (fileData) {
          const formData = new FormData()
          formData.append('files[]', fileData.file) // this is important! - the actual file for upload
          return formData // edit: fixed. Thanks to Chauhan-Nitesh for the comment below
        }
      )
      if (noOfFiles === 1) {
        this.$vs.loading({
          type:'radius',
          text:'Uploading File! Please Wait'
        })
      } else {
        this.$vs.loading({
          type:'radius',
          text:'Uploading Files! Please Wait'
        })
      }
      
      data.then((response, error) => {

        if (response) {
          const cdn = response[0].data.data.cdn
          for (let i = 0;  i < response.length; i++) {

            const file_name = response[i].data.data.files[0].file_name
            const file_path = response[i].data.data.files[0].file_path


            const raw = JSON.stringify({
              file_repository_id: this.repository_id,
              files: [
                {
                  file_name,
                  file_path: `${cdn}${file_path}`
                }
              ]
            })

            const uploadedFile = raw
            this.getUploadFiles(uploadedFile)
          }
          
        }  else {
          this.$vs.loading.close()

        }
      })
        .catch(error => {
          this.$vs.loading.close()
          this.errorMsg('Something Went Wrong')
        })
        .finally(this.$vs.loading.close())
      this.fileRecordsForUpload = []

    },

    // async getUploadFiles (uploadedFile, type = 'system') {
    //   try {
    //     const res = await addFile(uploadedFile)
    //     const fileDetails = res.data.data.files
    //     for (let index = 0; index < fileDetails.length; index++) {
    //       this.filesId.push(fileDetails[index].files_id) 
    //     }
    //     this.$vs.loading.close()
    //     // this.successMsg('File uploaded successfully')
    //   } catch (e) {
    //     this.$vs.loading.close()
    //     this.errorMsg('Something Went Wrong')
    //   }
    // },


    deleteUploadedFile (fileRecord) {
      // Using the default uploader. You may use another uploader instead.
      this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord)
    },
    filesSelected (fileRecordsNewlySelected) {
      const validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error)
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords)
    },
    onBeforeDelete (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1)
        const k = this.fileRecords.indexOf(fileRecord)
        if (k !== -1) this.fileRecords.splice(k, 1)
      } else if (confirm('Are you sure you want to delete?')) {
        this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event
      }
    },
    fileDeleted (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
      } else {
        this.deleteUploadedFile(fileRecord)
      }
    },
    successMsg (msg) {
      this.$vs.notify({
        title: 'Success',
        text: msg,
        color: 'success',
        iconPack: 'feather',
        icon: 'icon-alert-circle'
      })
    },
    errorMsg (msg) {
      this.$vs.notify({
        title: 'Warning',
        text: msg,
        color: 'warning',
        iconPack: 'feather',
        icon: 'icon-alert-circle'
      })
    },
    bytesToSize (bytes) {
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) return 'n/a'
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]})`
      return `${((bytes / 1024) ** i).toFixed(1)} ${sizes[i]}`
    },
    getImportFile ({ file_id, fileInfo }) {

      setTimeout(() => {
        this.isBrowseContent = false
        this.showSuccessMessage(
          'Success',
          'File Imported Successfully',
          'success'
        )
      }, 0)
      const importFileRecords = this.getImportedFile(fileInfo)

      this.filesInfo.push(
        ...importFileRecords.map((ele) => {
          return {
            file: {
              'file_name': ele.name,
              'file_path': ele.url,
              'size': ele.size,
              'file_type': ele.type
            }
          }
        })
      )
      // console.log()
      this.fileRecords.push(...importFileRecords)
      this.filesId = file_id

      // this.getIdFile(file_id)
    },
    getImportedFile (fileInfo) {
      return fileInfo.map((ele) => {
        return {
          name: ele.file_name,
          sizeText: this.bytesToSize(ele.size),
          size: ele.size,
          type: ele.file_type,
          url: ele.file_path,
          color: 'green',
          upload: {
            data: true,
            error: false
          }
        }
      })
    },
    async getUploadFiles (file_id_payload, type = 'system') {
      const res = await addFile(file_id_payload)

      if (res.data.message === 'files.createFile') {
        const file = {
          file: res.data.data.files[0]
        }
        this.filesInfo.push(file)

        // console.log()
        const filesDriveInfo = res.data.data.files
        let filesDrive = []
        if (type === 'drive') {

          filesDrive = filesDriveInfo.map(ele => {
            return {
              name: ele.file_name,
              sizeText: this.bytesToSize(ele.size),
              size: ele.size,
              type: ele.file_type,
              url: ele.file_path,
              color: 'green',
              upload: {
                data: true,
                error: false
              }
            }
          })
          this.fileRecords.push(...filesDrive)
        }
        this.filesId.push(res.data.data.files[0].files_id) 
        //const file_id = res.data.data.files[0].files_id
        // this.$vs.notify({
        //   title: 'Success',
        //   text: 'File Uploaded Successfully',
        //   iconPack: 'feather',
        //   icon: 'icon-alert-circle',
        //   color: 'success',
        //   time: 1000
        // })
        this.fileRecordsForUpload = []
     
        this.$vs.loading.close()
      }
    }

    
  }
}
</script>
<style scoped>
.vertical-divider {
  background-color: rgba(0, 0, 0, 0.1);
  width: 1px;
  position: relative;
  margin-left: 50px;
  margin-right: 50px;
}

.vertical-divider:after {
  content: "OR";
  width: 50px;
  height: 50px;
  font-weight: bold;
  border-radius: 50%;
  background-color: rgb(var(--vs-primary));
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.create-option {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  min-width: 220px;
  min-height: 125px;
}

.preview-button {
  cursor: pointer;
}

.preview-button:hover {
  color: rgb(var(--vs-primary));
}

.modal-slider {
  min-width: 250px !important;
}
.profile_image {
  height: 30px;
  width: 30px;
}

/* .customRadio .con-vs-radio figure {
  margin-top: -16px;
  margin-bottom: 10px;
} */
.swiper-container {
  padding: 20px 0;
  background-color: #fff;
}
.con-select {
  width: 100%;
}
.dropdown-menu {
  position: absolute;
  z-index: 99;
  background-color: #f8f8f8;
  left: 0;
  right: 0;
  box-shadow: 0 10px 15px -10px rgb(0 0 0 / 20%);
}
.dropdown-menu a {
  color: #626262;
}
.dropdown:hover .dropdown-menu {
  display: block !important;
}
.dropdown button {
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: #fff;
  color: #626262;
}
.vs-radio--input {
    position: absolute;
    left: 0;
    opacity: 0;
    width: 20px;
}
.customRadio .vs-radio {
    display: none;
}
.customRadio .con-vs-radio input{
  display: none;
}
/* article{
  background: #fff;
  box-shadow:0 4px 25px rgb(0 0 0 / 10%);
  padding:0 10px 10px;
} */
@media (max-width: 1024px) {
  .stepOne {
    display: block !important;
  }
  .vertical-divider {
    margin: 40px auto;
    visibility: hidden;
  }
}
</style>
<style>
.cstm_calendar_view_holder .right_view_panel.disableCheckbox .vs-checkbox-primary input {
  position: absolute;
  z-index: -1;
}
.cstm_calendar_view_holder .right_view_panel.disableCheckbox .vs-checkbox-primary input ~ .con-slot-label {
  opacity: 0.5;
  cursor: not-allowed;
}
.cstm_calendar_view_holder .right_view_panel.disableCheckbox .vs-checkbox-primary input:checked {
  position: absolute;
  z-index: unset;
}
.cstm_calendar_view_holder .right_view_panel.disableCheckbox .vs-checkbox-primary input:checked ~ .con-slot-label {
  opacity: 1;
  cursor: pointer;
}
</style>